<template>
	<div>
		<FormGroup label="Virksomhed" alias="organization" label-cols-md="3" v-slot:default="props" scope="related-organization">
			<OptifySelect :options="organizations" v-model="form.organizationId" :multiple="false" :show-labels="false"
				@search="search" @select="select" label="text" track-by="id" :internal-search="false" autocomplete="off">
			</OptifySelect>

			<input type="hidden" v-validate="'required'" v-model="form.organizationId" data-vv-as="Virksomhed"
				:class="{ 'is-invalid': !props.state }" name="organization" data-vv-scope="related-organization" />
		</FormGroup>
	</div>
</template>

<script>

export default {
	data: () => ({
		form: {
			contactId: null,
			organizationId: null,
		},
		organizations: []
	}),
	inject: ['$validator'],
	components: {},
	computed: {},
	watch: {},
	props: ["entity"],
	methods: {
		search(query) {			
			this.$http.post("/api/multi-select/organizations", {
				search: query,
				value: this.form.organizationId,
				values: [],
				taggable: true
			}).then(x => {
				this.organizations = x.data;
			});
		},
		select(item) {
			if (item.isNew === true) {
				this.$http.post("/api/multi-select/organizations/create", {
					name: item.text
				}).then(x => {
					this.form.organizationId = x.data.id;
					this.search();
				});
			}
		},
		ok() {
			this.$validator.validate("related-organization.*").then(valid => {
				if (valid) {
					this.entity.organizations.push(this.form.organizationId);
					// this.$http.post("/api/module/contacts/related-organization", this.form).then(x => {
					// 	this.$emit("close");
					// });
					this.$emit("close");
				}
			});
		},
		cancel() {
			this.$emit("close");
		}
	},
	created() {
		this.search();

		this.form.contactId = this.entity.Id;
	},
	mounted() {},
};
</script>